import axios from "axios";
import CryptoJS from "crypto-js";
import * as Sentry from "@sentry/react";
import { BASE_URL, CRYPTO_SECRET_KEY, IV_LENGTH } from "../constant/_constant";

//encrypt data function
function encryptData(data, encrypt = false) {
  if (encrypt) {
    const iv = CryptoJS.lib.WordArray.random(IV_LENGTH);
    const cipher = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY),
      { iv },
    );
    return {
      iv: iv.toString(CryptoJS.enc.Hex),
      encryptedText: cipher.toString(),
    };
  }
  return data;
}

//decrypt data function
function decryptData(encryptedData, decrypt = false) {
  if (decrypt) {
    const iv = CryptoJS.enc.Hex.parse(encryptedData.iv);
    const encryptedText = encryptedData.encryptedText;
    const bytes = CryptoJS.AES.decrypt(
      encryptedText,
      CryptoJS.enc.Utf8.parse(CRYPTO_SECRET_KEY),
      { iv },
    );
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return JSON.parse(decryptedData);
  }
  return encryptedData;
}

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to attach token to every request and encrypt data
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (config.data) {
      const encryptedData = encryptData(config.data);
      config.data = encryptedData;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle errors and decrypt data
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = decryptData(response.data);
    }
    return response;
  },
  (error) => {
    const decryptedData = decryptData(error.response.data);
    error.response.data = decryptedData;

    Sentry.captureException(error, {
      extra: {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        message: decryptedData?.message || null,
      },
    });

    return Promise.reject(error);
  },
);

export default axiosInstance;
